export default __webpack_public_path__ + "static/media/36I-102608_-15497_0.c35f9fb4.jpg";